import { useEffect, useState } from "react";
import EventScheduleCalender from "./components/calender";
import {
  EventScheduleWrapper,
  EventScheduleHeader,
  EventScheduleContentWrapper,
  EventScheduleTabWrapper,
} from "./style";
import { insetState } from "../../../recoil/inset";
import { useRecoilValue } from "recoil";
import { useHistory } from "react-router-dom";
import EventScheduleDateFilter from "./components/date-filter";
import { Overlay } from "../OddsCalc/styles";
import EventScheduleList from "./components/schedule-list";
import { useSchedule } from "./hook/useSchedule";
import EventComponent from "./components/event";

const EventSchedule = () => {
  const inset = useRecoilValue(insetState);
  const history = useHistory();
  const [calenderOpen, setCalenderOpen] = useState<boolean>(false);
  const [tab, setTab] = useState<"EVENT" | "SCHEDULE">("SCHEDULE");
  const {
    list,
    countList,
    renderDays,
    attendeeList,
    pubList,
    selectedAttendee,
    selectedPub,
    setSelectedAttendee,
    setSelectedPub,
    setYear,
    setMonth,
    date,
    setDate,
    getCountList,
    year,
    month,
  } = useSchedule();

  useEffect(() => {
    if (date) {
      const [year, month, _] = date.split("-");
      setYear(+year);
      setMonth(+month);
    }
  }, [date]);

  return (
    <EventScheduleWrapper isApp={inset}>
      {calenderOpen && (
        <EventScheduleCalender
          countList={countList}
          renderDays={renderDays}
          getCountList={getCountList}
          date={date}
          setDate={setDate}
          setCalenderOpen={setCalenderOpen}
          year={year}
          month={month}
        />
      )}
      <EventScheduleHeader isApp={inset}>
        <div className="close" onClick={() => history.push("/")}>
          <img src="/image-web/Icon/Back_white.svg" id="뒤로가기" alt="close" />
        </div>
        <div className="banner">
          <img
            src="https://dfesoodpx4jgd.cloudfront.net/events/event_banner.png"
            alt="banner"
          />
        </div>
        <div className="title">
          러너 <span>공식 엠버서더</span>
        </div>
      </EventScheduleHeader>
      <EventScheduleContentWrapper isApp={inset}>
        {/* <EventScheduleTabWrapper>
          <div
            className={`tab ${tab === "SCHEDULE" ? "selected" : ""}`}
            onClick={() => setTab("SCHEDULE")}
          >
            스케줄
          </div>
          <div
            className={`tab ${tab === "EVENT" ? "selected" : ""}`}
            onClick={() => setTab("EVENT")}
          >
            이벤트
          </div>
        </EventScheduleTabWrapper> */}
        {tab === "SCHEDULE" ? (
          <>
            <EventScheduleDateFilter
              renderDays={renderDays}
              countList={countList}
              date={date}
              setDate={setDate}
              selectedAttendee={selectedAttendee}
              selectedPub={selectedPub}
              setSelectedAttendee={setSelectedAttendee}
              setSelectedPub={setSelectedPub}
              setYear={setYear}
              setMonth={setMonth}
              attendeeList={attendeeList}
              pubList={pubList}
            />
            <EventScheduleList list={list} setCalenderOpen={setCalenderOpen} />
          </>
        ) : (
          <EventComponent />
        )}
      </EventScheduleContentWrapper>
      {calenderOpen && <Overlay />}
    </EventScheduleWrapper>
  );
};

export default EventSchedule;
